import styled from 'styled-components'
import { useDeleteErrorMessage, useErrorMessage } from '@entities/error-message/hooks'
import React from 'react'
import ModalWindow from '@shared/ModalWindow/ModalWindow'

const BodyModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 32rem;
    font-size: 1rem;
    padding-bottom: 2rem;
`
export const ErrorMessageDesktop = () => {
    const errorMessage = useErrorMessage()
    const deleteMessage = useDeleteErrorMessage()
    if (!errorMessage) return <React.Fragment />
    return (
        <ModalWindow
            title=""
            attrs={{
              'data-message-type': 'error'
            }}
            cancel={{
                text: 'Закрыть',
                clickHandler: deleteMessage
            }}>
            <BodyModalContainer>{errorMessage}</BodyModalContainer>
        </ModalWindow>
    )
}
